export const FILTER_VERSION = "5";
const FILTER_VERSION_LOCAL_STORAGE_BASE_KEY = "SCREENER_FILTERS_VERSION";

export const ALL_SCREENER_PREFIX = "ALL_SCREENERS_TABLE_";
export const ARCHIVED_SCREENER_PREFIX = "ARCHIVED_SCREENERS_TABLE_";
export const SCREENER_LOCATION_PREFIX = "SCREENER_LOCATIONS_TABLE_";
export const MY_LOCATIONS_PREFIX = "MY_LOCATIONS_TABLE_";
export const RESULTS_TABLE_PREFIX = "RESULTS_TABLE_";
const TABLE_PREFIXES = [
  ALL_SCREENER_PREFIX,
  ARCHIVED_SCREENER_PREFIX,
  SCREENER_LOCATION_PREFIX,
  MY_LOCATIONS_PREFIX,
  RESULTS_TABLE_PREFIX,
];

export const FILTER_PARAMS_LOCAL_STORAGE_BASE_KEY = "FILTER_PARAMS";

export const makeLocalStorageKeyByUser = (key: string, userId = "") =>
  `${key}_${userId}`;

export const filterVersionLocalStorageKey = (userId: string) =>
  makeLocalStorageKeyByUser(FILTER_VERSION_LOCAL_STORAGE_BASE_KEY, userId);

export const clearLocalStorageTableState = (userId: string) => {
  TABLE_PREFIXES.forEach((prefix) => {
    localStorage.removeItem(
      makeLocalStorageKeyByUser(
        `${prefix}${FILTER_PARAMS_LOCAL_STORAGE_BASE_KEY}`,
        userId,
      ),
    );
  });
};
